export default {"src":"/_next/static/media/Success.83868856.svg","height":41,"width":40};